import React from "react";
import { UserPartnershipTable } from "../../components/table/UserPartnershipTable";
import Wrapper from "../../components/wrapper/Wrapper";
import { FiUsers } from "react-icons/fi";

const UserPartnerships = () => {
  return (
    <Wrapper>
      {/* Header Section */}
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-gray-900 flex items-center gap-3">
          <FiUsers className="w-8 h-8 text-[--primary]" />
          User Partnerships
        </h1>
        <p className="text-gray-600 mt-2">
          Manage and track user partnership applications and their status
        </p>
      </div>

      {/* User Partnerships Table */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
        <UserPartnershipTable />
      </div>
    </Wrapper>
  );
};

export default UserPartnerships;
